import React, { useEffect, useState } from "react";
import NotificationService from "../../services/Notification";
import { SingleWhatsappTemplateRow } from "../../components/List/SingleWhatsappTemplateRow";
export const WhatsappTemplateList = () => {
  const [list, setList] = useState<any>([]);
  const fetchData = async () => {
    NotificationService.getWhatsappTemplates()
      .then((res: any) => {
        setList(res.data);
      })
      .catch((error: any) => {
        console.log(error);
      });
  };
  useEffect(() => {
    fetchData();
  }, []);
  return (
    <>
      <div className="main-wrapper">
      <div className="page_title py-2">Notifications - Whatsapp Notification</div>
        <div className="p-4">
          {/* Main secttion */}
          <div className="main-section">
            <table className="table">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Body</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {list && list.length > 0 ? (
                  list.map((el: any) => (
                    <SingleWhatsappTemplateRow key={el._id} props={el} />
                  ))
                ) : (
                  <h1 className="no-data">No Data Found</h1>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
  
};
